import React from 'react';

import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import ComparisonTableBody from 'components/ModularBlocks/ComparisonTable/components/ComparisonTableBody';
import ComparisonTableHeader from 'components/ModularBlocks/ComparisonTable/components/ComparisonTableHeader';
import MobileComparisonTable from 'components/ModularBlocks/ComparisonTable/components/MobileComparisonTable';

import { ComparisonTableI } from 'interfaces/content-stack/modular-blocks/comparisonTable';

import { buildBasicRows } from 'utils/functions';

const COMPARISON_ROW = 'Comparison Row';

const Table = styled.table<{ $mobileStyle: string }>`
  font-weight: 400;
  margin-bottom: 1em;
  width: 100%;

  ${ifProp(
    { $mobileStyle: 'Comparison Row' },
    css`
      display: none;

      @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        display: table;
      }
    `
  )}
`;

export interface ComparisonTableProps {
  data: ComparisonTableI;
  className?: string;
}

const ComparisonTable: React.FC<ComparisonTableProps> = ({ data, className }) => {
  if (!data) {
    return null;
  }

  const { mobileTableStyle, tableHeaders, tableColumns } = data;
  const rows = buildBasicRows(tableColumns);

  return (
    <div className={className}>
      <Table $mobileStyle={mobileTableStyle}>
        {tableHeaders.length > 0 && <ComparisonTableHeader headers={tableHeaders} mobileStyle={mobileTableStyle} />}
        {tableColumns.length > 0 && (
          <ComparisonTableBody columns={tableColumns} mobileStyle={mobileTableStyle} rows={rows} />
        )}
      </Table>
      {mobileTableStyle === COMPARISON_ROW && <MobileComparisonTable headers={tableHeaders} columns={tableColumns} />}
    </div>
  );
};

export default React.memo(ComparisonTable);
